import { cn } from '@/shadcn/lib/utils';

interface Props {
    children: React.ReactNode;
    className?: string | string[];
}

export function AboutUsButton(props: Props) {
    return (
        <button
            className={cn(
                'mt-[30px]',
                'inline-flex items-center justify-center rounded-full bg-[#191919] px-7 py-3 text-[13px] font-[500] text-white transition-transform duration-200',
                'relative z-[21] cursor-pointer',
                props.className,
            )}
        >
            {props.children}
        </button>
    );
}
